import _ from 'lodash'
import { FETCH_REFUNDS, CREATE_REFUND } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_REFUNDS:
      return action.payload
    case CREATE_REFUND:
      return action.payload
    default:
      return state
  }
}
